module.exports = __webpack_public_path__ + "static/media/tataPowerTestimonialIcon.b3280298.svg";